import React, { Component } from "react";
import Loading from "./../utils/Loading";

import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import swal from "sweetalert";

export const ModalDevolucionProductoNoPoa = (props) => {
  const toggle = () => props.activarModalDevolucionProductoNoPoa(props.modalDevolucion);
  let comentarioRef = React.createRef();
  const { modalDevolucion } = props;
  return (
    <Modal isOpen={modalDevolucion} toggle={toggle} size="lg" backdrop="static">
      <ModalHeader className="block-example border-bottom " toggle={toggle}>
        Motivo Devolución Producto No Poa
      </ModalHeader>
      <ModalBody>
        <textarea
          placeholder="Motivo de la devolución"
          ref={comentarioRef}
          className="form-control"
          rows="3"
        ></textarea>
      </ModalBody>
      <ModalFooter>
        <button
          className="btn btn-danger btn-sm"
          onClick={(e) => {
            e.preventDefault();
            if (
              comentarioRef.current != null &&
              comentarioRef.current.value !== ""
            ) {
              props.devolverProductoAprobado(
                comentarioRef.current.value
              );
            } else {
              swal("Producto No POA","El motivo de la devolución es un valor requerido para devolver el producto","error");
            }
          }}
        >
          Devolver
        </button>
        <button
          className="btn btn-info btn-sm"
          onClick={(e) => {
            e.preventDefault();
            toggle();
          }}
        >
          Cancelar
        </button>
      </ModalFooter>
    </Modal>
  );
};
